module.exports = __webpack_public_path__ + "media/images/application/podcast/banner-podcast-c4c9f9e45abd11dcc50236f751b2b1aa.jpg";